import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditTeamComponent } from './team/edit-team.component';
import { TeamComponent } from './team/team.component';
import { TeamMemberComponent } from './member/team-member.component';
import { CreateTeamDialogComponent } from './dialog/create-team-dialog/create-team-dialog.component';
import { UpdateTeamMemberDialogComponent } from './dialog/update-team-member-details-dialog/update-team-member-details-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MsalGuard } from '@azure/msal-angular';
import { MaterialModule } from '../material.module';
import { AddTeamMemberDialogComponent } from './dialog/add-team-member-dialog/add-team-member-dialog.component';
import { OnCallHomeComponent } from './home/oncall-home.component';
import { OnCallNavmenuComponent } from './navmenu/oncall-navmenu.component';
import { RouterModule, Routes } from '@angular/router';
import { AlertComponent } from './alert/alert.component';
import { OnCallComponent } from './oncall.component';
import { AlertOnCallDialogComponent } from './dialog/alert-oncall-dialog/alert-oncall-dialog.component';
import { ClipboardModule } from '@angular/cdk/clipboard';

const appRoutes: Routes = [
  {
    path: 'oncall',
    component: OnCallComponent,
    canActivate: [MsalGuard],
    children: [
      {
        path: '',
        component: OnCallHomeComponent,
        canActivate: [MsalGuard]
      },
      {
        path: 'alerts',
        component: AlertComponent,
        canActivate: [MsalGuard]
      },
      {
        path: 'teams',
        component: TeamComponent,
        canActivate: [MsalGuard]
      },
      {
        path: 'teams/edit/:id',
        component: EditTeamComponent,
        canActivate: [MsalGuard]
      },
      {
        path: 'members',
        component: TeamMemberComponent,
        canActivate: [MsalGuard]
      }
    ]
  }
];

@NgModule({
  declarations: [
    OnCallComponent, OnCallHomeComponent, OnCallNavmenuComponent, AlertComponent, TeamComponent, EditTeamComponent, TeamMemberComponent,
    CreateTeamDialogComponent, UpdateTeamMemberDialogComponent, UpdateTeamMemberDialogComponent, AddTeamMemberDialogComponent, AlertOnCallDialogComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    ClipboardModule,
    RouterModule.forChild(appRoutes),
  ],
  exports: [
    OnCallComponent, OnCallNavmenuComponent
  ],
})
export class OnCallModule { }
